import type { AxiosResponse } from "axios";

import { validateValues } from "../../utils";
import api from "../../../../../api";
import type { IUser } from "../../../../../types";
import { CommandFormValues } from "../../types";
import { resetSkippedIncomeTaxSchema } from "./types";

export const handleResetSkippedIncomeTax = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { date } = validateValues(values, resetSkippedIncomeTaxSchema);

  return await api.kontax.resetSkippedIncomeTax(user.id, date);
};
